import React, { useEffect, useState, useMemo } from 'react';
import {
    ModalContentWrapper,
    NotFoundDiv,
    SelectDiv,
    TickersSelectWrapper,
    TickersTitle,
    TopElementsDiv
} from "../CPSettingsBlock/cPSettingsBlockStyles";
import SpItem from "./SPItem";
import { useAppSelector } from "hooks/redux";
import { useDispatch } from "react-redux";
import { getSPParams, resetSavedSP, setSavedSP, saveSettingsItem } from "store/reducers/SettingsSlice";
import createObject from "utils/createObject";
import omit from 'lodash-es/omit'
import cPTypeCheck from "../../../utils/cPTypeCheck";
import Error from "../../../utils/Notifications/Error";
import TPH from 'utils/trade-params-handler';

const SPList = () => {
    const {
        resetKey,
        savedSettings,
        MDPSelectedItem,
        error,
        settings,
        settings_defaults,
        nativeSP,
        SPTypes,
        saved_settings,
        activeGroup,
        activeTicker
    } = useAppSelector(state => state.settings)
    const dispatch = useDispatch()
    const [SPData, setSPData] = useState({})
    // const {['ID.source']: source, ...file} = SPData

    useEffect(() => {
        if (MDPSelectedItem.SPname === '') return
        // const { SP } = settings
        const { SP: savedLocalSp } = savedSettings
        const [spKeys, ...spValues] = savedLocalSp
        const pickedSPArray = spValues.filter(arr => {
            // фильтруем по нужному инструменту

            return arr[0] === MDPSelectedItem.SPname?.replace("::copy", "")
        })[0]

        try {
            let sPArrayFullSourceName: string[]
            if (pickedSPArray === undefined) {
                const blankSPArray = new Array(8).fill("")
                const localSPArray = [MDPSelectedItem.SPname, "", ...blankSPArray]
                sPArrayFullSourceName = localSPArray

                dispatch(setSavedSP([...savedLocalSp, localSPArray]))
                // dispatch(setSavedSP([...localSP, localSPArray]))
            } else {
                sPArrayFullSourceName = pickedSPArray?.map(base => {
                    if (base === MDPSelectedItem.SPname.split(" ")[0]) {
                        return MDPSelectedItem.SPname
                    }
                    return base
                })
            }
            const spData = createObject(spKeys, [...sPArrayFullSourceName])
            setSPData(omit(spData, ['ID.source']) as {})
            // setSPData(spData)
        } catch (e) {
            setSPData([])
        }

    }, [MDPSelectedItem.SPname, settings.SP, nativeSP])

    const handleInputChange = (value: string, key: string) => {
        // здесь обрабатываем изменение полей CP
        const { SP: localSP } = savedSettings
        const { currentType, isRightType } = cPTypeCheck(key, value, SPTypes)
        if (isRightType) {
            const localSPArrIndex = localSP.findIndex(i => i.includes(MDPSelectedItem.SPname.split(" ")[0]))
            const newLocalValues = localSP.map((item, index) => {
                return index === localSPArrIndex ? item.map((item, index) => {
                    return (index === localSP[0].indexOf(key)) ? value : item
                }) : item
            })

            dispatch(setSavedSP(newLocalValues))

        } else {
            Error(`Неправильный тип. Тип поля ${currentType}`)
        }
    }

    useEffect(() => {
        dispatch(getSPParams())
    }, [])

    useEffect(() => {
        //dispatch(resetSavedSP())
    }, [MDPSelectedItem.SPname])

    const _handleInputChange = (value, key) => {
        const type = TPH.findParamType(key);
        const valid = TPH._validate({
            key,
            value
        });
        if (!valid) {
            Error(`Неправильное значение. Тип поля: ${type}`);
        }
        const affiliation = {
            ticker_name: activeTicker?.name,
            group_name: activeGroup?.name,
            exchange_name: MDPSelectedItem?.SPname
        }
        dispatch(saveSettingsItem({
            key,
            value,
            affiliation
        }));
        const newSP:string[][] = JSON.parse(JSON.stringify(savedSettings.SP)) 
        const indexOfSPParams = newSP.findIndex((SPArray) => SPArray[0] === MDPSelectedItem.SPname)
        const internalIndexOfSPInsideTheArray = keys_order.findIndex((nameOfParam) => nameOfParam === key) 
        if(~indexOfSPParams){
            const newTikerSPParams = newSP[indexOfSPParams].slice()
            newTikerSPParams[internalIndexOfSPInsideTheArray + 1] = value // +1 because the 0 index for the name of the stock market 
            newSP[indexOfSPParams] = newTikerSPParams
            dispatch(setSavedSP(newSP))
        }

    }
    const DEFAULT = settings_defaults['SP'];
    const keys_order = DEFAULT.map(x => x.key);
    const __SPData = useMemo(() => {
        let data = saved_settings.filter(x => {
            const { affiliation } = x;
            if (typeof affiliation !== 'object') {
                return false;
            }
            const active_group = activeGroup && activeGroup.name;
            if (
                affiliation.exchange_name === MDPSelectedItem?.SPname &&
                affiliation.group_name === active_group &&
                affiliation.ticker_name === activeTicker?.name
            ) {
                return true;
            }
        });
        if (data.length < DEFAULT.length) {
            const _data = DEFAULT.map(x => data.find(y => y.key === x.key) ? data.find(y => y.key === x.key) : x);
            data = _data;
        }
        // I know that's not the way how to do it rigth, but i don't even want dive into the saved_settings obj because is messed "a little"
        const currentSPValues = savedSettings.SP.find((SPArray) => SPArray[0] === MDPSelectedItem?.SPname)?.slice(1)
        return data.sort((a, b) => keys_order.indexOf(a.key) - keys_order.indexOf(b.key)).map((SPinfo, index) => {
            if(currentSPValues){
                return {...SPinfo, value: currentSPValues[index]}
            }
            return SPinfo
        })
    }, [activeGroup, activeTicker, saved_settings, MDPSelectedItem, savedSettings.SP]);
    const _SPData = Array.isArray(__SPData) && __SPData.length ? __SPData : DEFAULT;
    return (
        <ModalContentWrapper>
            <TickersSelectWrapper>
                <TopElementsDiv>
                    <TickersTitle>
                        Название
                    </TickersTitle>
                    <TickersTitle>
                        Значение
                    </TickersTitle>
                </TopElementsDiv>
                <SelectDiv>
                    {error && <NotFoundDiv>Тикер занят другим пользователем</NotFoundDiv>}
                    {/* {SPData.toString() === "" && <NotFoundDiv>SP data not found...</NotFoundDiv>} */}
                    {
                    Array.isArray(_SPData) ?
                    _SPData.map(({ key, value, has_change }) => (
                        <SpItem
                        key={`sp-item-${key}`}
                        name={key}
                        has_change={ has_change }
                        currentValue={value}
                        isInput={true}
                        onInputChange={(redirectedValue: string) => _handleInputChange(redirectedValue, key)}                    
                        />
                    ))
                    :
                    Object.entries(SPData).map(([key, value]) =>
                        <SpItem
                            key={key + MDPSelectedItem + 'sp-item'}
                            name={key}
                            currentValue={value}
                            isInput={true}
                            onInputChange={(redirectedValue: string) => handleInputChange(redirectedValue, key)}
                        />
                    )
                    }
                </SelectDiv>
            </TickersSelectWrapper>
        </ModalContentWrapper>


    );
};

export default SPList;